import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
import { Animated, View } from 'react-native';
import { checkIsPlatform, getTestId } from '@airtel/air-design-system';
import { getSectionTitleWidgetStyles } from '../../SectionTitleWidgetStyles';
export var SnapIndicator = props => {
  var onAnimationEnd = props.onAnimationEnd,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'SnapIndicator' : _props$testID,
    snapBgColor = props.snapBgColor,
    _props$dataLength = props.dataLength,
    dataLength = _props$dataLength === void 0 ? 0 : _props$dataLength;
  var prevIndex = useRef(null);
  var widths = useRef(Array.from({
    length: dataLength
  }).slice(0, 3).map(() => new Animated.Value(4)));
  var translates = useRef(Array.from({
    length: dataLength
  }).slice(0, 3).map(() => new Animated.Value(0)));
  var currIndex = props.currIndex % 3;
  var sectionTitleWidgetStyles = getSectionTitleWidgetStyles(undefined, snapBgColor);
  useEffect(() => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (dataLength > 0 && widths.current.length > currIndex) {
      (_a = Animated.spring(widths.current[currIndex], {
        toValue: 20,
        useNativeDriver: false,
        isInteraction: false
      })) === null || _a === void 0 ? void 0 : _a.start();
      if (prevIndex.current != undefined) {
        if (prevIndex.current % 3 === currIndex) {
          (_c = (_b = translates.current[prevIndex.current % 3]) === null || _b === void 0 ? void 0 : _b.setValue) === null || _c === void 0 ? void 0 : _c.call(_b, 0);
        }
      }
      (_d = Animated.timing(translates.current[currIndex], {
        toValue: 0,
        duration: props.duration,
        useNativeDriver: !checkIsPlatform('web'),
        isInteraction: false
      })) === null || _d === void 0 ? void 0 : _d.start(_ref => {
        var finished = _ref.finished;
        if (finished) {
          onAnimationEnd === null || onAnimationEnd === void 0 ? void 0 : onAnimationEnd();
        }
      });
      if (prevIndex.current != undefined) {
        if (prevIndex.current % 3 != currIndex) {
          (_e = Animated.spring(widths.current[prevIndex.current % 3], {
            toValue: 4,
            useNativeDriver: false,
            isInteraction: false
          })) === null || _e === void 0 ? void 0 : _e.start();
        }
        var idx = prevIndex.current % 3;
        if (translates.current && translates.current.length > idx && idx != currIndex) {
          (_g = (_f = translates.current[idx]) === null || _f === void 0 ? void 0 : _f.setValue) === null || _g === void 0 ? void 0 : _g.call(_f, 0);
        }
      }
      prevIndex.current = props.currIndex;
    }
  }, [props.currIndex]);
  if (dataLength <= 0) {
    return null;
  }
  return _jsx(View, Object.assign({
    style: sectionTitleWidgetStyles.snapContainer
  }, getTestId(testID), {
    children: Array.from({
      length: dataLength
    }).slice(0, 3).map((_item, index) => {
      var _a;
      return _jsx(Animated.View, Object.assign({
        style: [sectionTitleWidgetStyles.snap, {
          width: widths.current[index]
        }]
      }, {
        children: currIndex == index ? _jsx(Animated.View, {
          style: getSectionTitleWidgetStyles([{
            translateX: (_a = translates.current[index]) !== null && _a !== void 0 ? _a : 0
          }], snapBgColor).snapProgress
        }) : null
      }), index.toString());
    })
  }));
};
SnapIndicator.defaultProps = {
  onAnimationEnd: () => null,
  dataLength: 0,
  currIndex: 0,
  duration: 5000
};